import React, { useContext } from "react";
import MyLayout from "../../../layouts/customer/MyLayout";
import AppContext from "../../../context/AppContext";
import AboutHeroSection from "../../../subscreens/customer/aboutHeroSection/AboutHeroSection";
import OurStorySection from "../../../subscreens/customer/ourStorySection/OurStorySection";
import OurValuesSection from "../../../subscreens/customer/ourValuesSection/OurValuesSection";
import OurJourneySection from "../../../subscreens/customer/ourJourneySection/OurJourneySection";
import WhyDistributorsSection from "../../../subscreens/customer/whyDistributorsSection/WhyDistributorsSection";
// import AboutHeroSection from "../home/subscreens/aboutScreen/AboutHeroSection";
// import OurStorySection from "../home/subscreens/aboutScreen/OurStorySection";
// import OurValuesSection from "../home/subscreens/aboutScreen/OurValuesSection";
// import OurJourneySection from "../home/subscreens/aboutScreen/OurJourneySection";
// import WhyDistributorsSection from "../home/subscreens/aboutScreen/WhyDistributorsSection";
// import "../../../assets/styles/customer/components/About.css";

const About = () => {
  const { selectedDistributor } = useContext(AppContext);
  return (
    <MyLayout>
      {/* <h1>This is About Page</h1>
      <h2>{selectedDistributor}</h2> */}
      <AboutHeroSection/>
      <OurStorySection/>
      <OurValuesSection/>
      <OurJourneySection/>
      <WhyDistributorsSection/>
    </MyLayout>
  );
};

export default About;
